"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _ButtonBase = _interopRequireDefault(require("@material-ui/core/ButtonBase"));

var _IconButton = _interopRequireDefault(require("@material-ui/core/IconButton"));

var _Link = _interopRequireDefault(require("@material-ui/icons/Link"));

var _styles = require("@material-ui/core/styles");

var _ = require("../..");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const useStyles = (0, _styles.makeStyles)(theme => ({
  root: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    padding: theme.spacing(1),
    border: "1px solid",
    borderColor: theme.palette.divider,
    backgroundColor: "inherit",
    minHeight: theme.spacing(7),
    overflow: "hidden"
  },
  icon: {
    display: "flex",
    padding: theme.spacing(1.5)
  },
  label: {
    fontFamily: "Akkurat, sans-serif"
  },
  trailingIcons: {
    display: "flex"
  },
  navSettings: {
    display: "flex",
    margin: theme.spacing(1)
  },
  navToolbar: {
    display: "flex",
    margin: theme.spacing(1)
  },
  content: {
    flexGrow: 1,
    display: "flex",
    flexDirection: "column",
    flexBasis: "100%",
    width: "100%",
    overflow: "hidden",
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1)
  },
  header: {},
  footer: {}
}));

const KioskLinkReference = ({
  formData,
  formContext,
  sidebar
}) => {
  const referenceId = formData.referenceId,
        reference = formData.reference;
  const classes = useStyles();
  const onDialog = formContext && formContext.onReferenceDialog;
  const onChange = formContext && formContext.onReferenceChange;
  const toolbar = [{
    icon: "remove_circle",
    onClick: () => onChange({
      referenceId: undefined,
      reference: {}
    })
  }]; // linkId

  if (referenceId && reference) {
    return _react.default.createElement("section", {
      "data-name": "reference"
    }, _react.default.createElement(_.ModuleBase, {
      className: classes.root
    }, _react.default.createElement(_IconButton.default, {
      className: classes.icon,
      onClick: () => onDialog(sidebar.query)
    }, _react.default.createElement(_Link.default, null)), _react.default.createElement("div", {
      className: classes.content
    }, _react.default.createElement("header", {
      className: classes.header
    }, _react.default.createElement(_.ModuleTitle, {
      title: reference && reference.title
    })), _react.default.createElement("footer", {
      className: classes.footer
    }, _react.default.createElement(_.ModuleDescription, {
      description: reference && referenceId
    }))), _react.default.createElement(_.NavToolbar, {
      toolbar: toolbar
    })));
  } // 1. Add link


  return _react.default.createElement(_ButtonBase.default, {
    className: classes.root,
    "data-name": "reference",
    onClick: () => onDialog(sidebar.query)
  }, _react.default.createElement("i", {
    className: classes.icon
  }, _react.default.createElement(_Link.default, null)), _react.default.createElement(_.ModuleTitle, {
    className: classes.label
  }, "Add a link"));
};

var _default = KioskLinkReference;
exports.default = _default;
module.exports = exports.default;